module.exports = {
	basePageTitle: 'Carol Langley',
};
